import { axios } from '@/plugins/axios';
import { ServiceItem } from '@/models/quote-template';

export class QuoteServiceItemService {
  private endpoint: string;

  constructor() {
    this.endpoint = 'v1/quotes/templates/services/';
  }

  async createQuoteService(service: ServiceItem) {
    return axios
      .post<ServiceItem>(`${this.endpoint}`, service)
      .then(({ data }) => data);
  }

  async fetchQuoteServices(language = 'en') {
    return axios
      .get<ServiceItem[]>(`${this.endpoint}`, {
        headers: {
          'Accept-Language': language
        }
      })
      .then(({ data }) => data);
  }

  async fetchQuoteService(id: number) {
    return axios
      .get<ServiceItem>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }

  async updateQuoteService(service: ServiceItem) {
    return axios
      .patch<ServiceItem>(`${this.endpoint}${service.id}/`, service)
      .then(({ data }) => data);
  }

  async deleteQuoteService(id: number) {
    return axios.delete(`${this.endpoint}${id}/`);
  }
}
